import { LoginData, LoginError } from 'auth/models';
import { FetchDataError } from 'shared/http/models/fetch-data';
import { FetcherService } from 'shared/http/models/fetcher-service';
import { useFetcherService } from 'shared/http/hooks/useFetcherService';

class ImpersonationService extends FetcherService {
  private mapToLoginError(e: FetchDataError): LoginError {
    return new LoginError(e.apiError, e.statusCode);
  }

  async loginAsUser(username: string) {
    const url = `auth/login/impersonate?username=${encodeURIComponent(username)}`;
    return this.post<LoginData>(url, {}).catch((e: FetchDataError) => {
      throw this.mapToLoginError(e);
    });
  }

  async exitImpersonation() {
    return this.post<LoginData>('auth/login/impersonate/exit', {}).catch(
      (e: FetchDataError) => {
        throw this.mapToLoginError(e);
      },
    );
  }
}

const impersonationService = new ImpersonationService();

export function useImpersonationService() {
  const { registerFetcherService } = useFetcherService();

  registerFetcherService(impersonationService);

  return impersonationService;
}
